import React from "react";

const SendReminderIcon2 = () => {
  return (
    <div>
      <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.583 1.667V5M5.417 1.667V5M17.5 10V3.335h-15v15H10"
          stroke="#344054"
          strokeWidth={1.2}
          strokeLinejoin="round"
        />
        <path
          d="M2.5 7.5h15"
          stroke="#344054"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 16.995v1.339m0-1.34a2.483 2.483 0 01-2.055-1.072M15 16.994c.857 0 1.612-.427 2.055-1.074M15 12.174c.857 0 1.612.427 2.055 1.074M15 12.173c-.857 0-1.612.427-2.055 1.074M15 12.173v-1.339m3.333 1.5l-1.278.913m-5.388 3.587l1.278-.912m-1.278-3.588l1.278.913m5.388 3.587l-1.278-.912m0-2.675a2.36 2.36 0 010 2.675m-4.11-2.675a2.36 2.36 0 000 2.675"
          stroke="#344054"
          strokeWidth={1.2}
        />
      </svg>
    </div>
  );
};

export default SendReminderIcon2;
